import { Icon } from "@material-ui/core";
import React from "react";
import styled from "styled-components";

import { ActionPermissionsObject } from "common/interfaces";
import AppController from "js/core/AppController";
import WorkspaceController from "js/controllers/WorkspaceController";
import { t } from "js/i18n";
import { themeColors } from "js/react/sharedStyles";
import { TeamResourceTypes } from "js/react/views/TeamResources/TeamResourceTypes";

const ManageTemplatesLinkButton = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 2px;
    margin: 0;
    padding: 0;
    border: none;
    background: transparent;
    cursor: pointer;
    color: ${themeColors.ui_blue};
    font-family: "Source Sans Pro", sans-serif;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.025em;
    text-transform: uppercase;
    white-space: nowrap;

    .MuiIcon-root {
        font-size: 16px;
        color: ${themeColors.ui_blue};
    }

    &:hover {
        opacity: 0.85;
    }
`;

export function ManageTemplatesLink({ visible = false }: { visible?: boolean }) {
    // early return if the link is not visible
    if (!visible) {
        return null;
    }

    const canManageTemplates = WorkspaceController.actionPermissions[ActionPermissionsObject.SHARED_RESOURCES].manage;
    if (!canManageTemplates) {
        return null;
    }

    return (
        <ManageTemplatesLinkButton
            type="button"
            data-test-id="manage-templates-link"
            onClick={() => AppController.showTeamResources({ pane: TeamResourceTypes.PRESENTATION_TEMPLATES })}
        >
            {t("Manage Templates")}
        </ManageTemplatesLinkButton>
    );
}
